module.exports = __webpack_public_path__ + "static/media/user_group.bb3d5b11.svg";